export default __webpack_public_path__ + "static/media/firefox.f2afdfeb.png";